// import * as links from './links';
import axios from 'axios';

function makeURL(url, params) {
    let replaced = url;
    if (Object.keys(params).length){
        for (let k in params) {
            replaced = replaced.replace(`:${k}`, params[k])
        }
    }
    return replaced;
}

export function fetch(url, params = {}) {
    url = makeURL(url, params);
    if (process.env.NODE_ENV === 'development1') {
        console.info('GET', url);
        return new Promise((res, rej) => {
            rej(`Default fetch!\n---> ${url}`)
        })        
    } else {
        return axios.get(url, {
            // withCredentials: true,
            headers: {
                'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods':'GET,PUT,POST,DELETE,PATCH,OPTIONS',
              }
        })
        .then(res => res.data)
        .catch(e => {
            throw e.response?.data?.message || e.toString();
        })
    }
}

export function update(url, data = {}) {
    url = makeURL(url, data.params);
    if (process.env.NODE_ENV === 'development1') {
        console.info('PUT', url, data.data);
        return new Promise((res, rej) => {
            rej(`Default update!\n---> ${url}`)    
        })        
    } else {
        return axios.put(url, data.data, {withCredentials: true})
        .then(res => res.data)
        .catch(e => {
            throw e.response ? e.response.data.message : e;
        })    
    }
}

export function create(url, data = {}) {
    url = data.params ? makeURL(url, data.params) : url;
    if (process.env.NODE_ENV === 'development1') {
        console.info('POST', url, data.data);
        return new Promise((res, rej) => {
            rej(`Default create!\n---> ${url}`)
        })
    } else {
        return axios.post(url, data.data, {
            // withCredentials: true,
            headers: {
                'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods':'GET,PUT,POST,DELETE,PATCH,OPTIONS',
              }
        })
        .then(res => res.data)
        .catch(e => {
            throw e.response ? e.response.data.message : e;
        })
    }
}

export function patch(url, data = {}) {
    url = makeURL(url, data.params);
    return axios.patch(url, data.data, {
        // withCredentials: true,
        headers: {
            'Access-Control-Allow-Origin' : '*',
            'Access-Control-Allow-Methods':'GET,PUT,POST,DELETE,PATCH,OPTIONS',
          }
    })
        .then(res => res.data)
        .catch(e => {
            throw e.response ? e.response.data.message : e;
        })
}

export function remove(url, params = {}) {
    url = makeURL(url, params);
    return axios.delete(url, {data: {}, 
        // withCredentials: true,
        headers: {
            'Access-Control-Allow-Origin' : '*',
            'Access-Control-Allow-Methods':'GET,PUT,POST,DELETE,PATCH,OPTIONS',
        }
    })
        .then(res => res.data)
        .catch(e => {
            throw e.response ? e.response.data.message : e;
        })
}